export default __webpack_public_path__ + "75cd6f9b50393c282543915eeac71826.woff2";